/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContratHistorySearchDto
 */
export interface ContratHistorySearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContratHistorySearchDto
     */
    idcontrat?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratHistorySearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContratHistorySearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContratHistorySearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratHistorySearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContratHistorySearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContratHistorySearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContratHistorySearchDto interface.
 */
export function instanceOfContratHistorySearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratHistorySearchDtoFromJSON(json: any): ContratHistorySearchDto {
    return ContratHistorySearchDtoFromJSONTyped(json, false);
}

export function ContratHistorySearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratHistorySearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContratHistorySearchDtoToJSON(value?: ContratHistorySearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontrat': value.idcontrat,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

